var Quiz = (function($) {

  var init = function() {
    var completed = [];
    var completedIndex = false;
    
    var questions = [
      { 
        contextText: "",
        question: "What kind of food are you craving?",
        image: "sweet-or-savory",
        answers: [
          {
            name: "Something Savory",
            next: 1,
          },
          {
            name: "Something Sweet",
            next: 2
          }
        ]
      },
      {
        contextText: "You’re in luck, we have a great selection of savory foods.",
        question: "Are you looking for a meal or a snack?",
        image: "savory",
        answers: [
          {
            name: "Just a light snack",
            results: {
              heading: "We don’t like to play favorites, but we think you’ve made the smart choice!",
              text: "We think you’ll love, <strong>Quest Tortilla Style Protein Chips</strong>. They come in a variety of savory flavors like Loaded Taco and Nacho Cheese. Plus they have at least 17g of protein and 4g net carbs or less per serving no matter which flavor or size you choose.",
              buttonText: "Shop Quest Chips Today",
              url: "https://www.questnutrition.com/collections/protein-chips",
              image: "chips"
            }
          },
          {
            name: "I'm hungry for a meal!",
            results: {
              heading: "We can tell you’re hungry, so we’ll make this quick.",
              text: "You want <strong>Quest Pizza</strong>. If you’ve never tried them, we can confidently say you’re going to be surprised at how good they taste with only 5-6g net carbs per serving. Thin Crust or Loaded – either choice leads to an incredible pizza experience without loading up on the bad stuff you don’t want in pizza.  Track down all 4 flavors of our pizzas using our store locator.", 
              buttonText: "Store Locator",
              url: "https://www.questnutrition.com/pages/store-locator",
              image: "pizza_quiz"
            }
          }
        ]
      },
      {
        contextText: "We like sweets, too.",
        question: "Are you looking for something indulgent and snacky or something sweet & substantial?",
        image: "indulgent-substantial",
        answers: [
          {
            name: "Indulgent & snacky please!",
            next: 3
          },
          {
            name: "Sweet & substantial, please!",
            next: 4
          }
        ]
      },
      {
        contextText: "So you’ve got a sweet tooth, huh? You’re in the right place! The next question has three answers, so choose carefully. ",
        question: "Which sounds best to you right now?",
        image: "sweet",
        answers: [
          {
            name: "A soft & chewy cookie!",
            results: {
              heading: "You can’t go wrong with our soft & chewy Quest Protein Cookies.",
              text: "All the flavors you love are there, and best of all, our cookies are sweet with 1g of sugar or less.",
              buttonText: "Shop Quest Cookies Today",
              url: "https://www.questnutrition.com/collections/protein-cookies",
              image: "cookies"
            }
          },
          {
            name: "Something sweet with a crunch!",
            results: {
              heading: "It’s all about the texture, we couldn’t agree more.",
              text: "Thankfully <strong>Quest Snack Bars</strong> are snackable treats that are lightly sweet with a crunchy texture that has the perfect amount of chewiness to it. The best part? Each bar has 10g of protein, 5g net carbs and 1 gram of sugar or less.",
              buttonText: "Shop Quest Snack Bars Today",
              url: "https://www.questnutrition.com/collections/snack-bars",
              image: "snack-bars"
            }
          },
          {
            name: "Chocolatey Candy!",
            results: {
              heading: "So you want decadent indulgence.",
              text: "You’re going to love <strong>Quest Peanut Butter Cups, Candy Bites and Candy Bar</strong>. The best part about our sweets is that they’re sweet without all the sugar. Each product tastes like the real deal and have 1g of sugar or less. Honestly, you have to taste them to truly believe how good they are, so we’ll let you get to it!",
              buttonText: "Shop Quest Candy Today",
              url: "https://www.questnutrition.com/collections/candy",
              image: "candy"
            }
          }
        ]
      },
      {
        contextText: "Smart choice. We also like to eat something that’s going to keep us full between meals with admirable macros. Good on you.",
        question: "We’ve got a three-part question ahead, so really think about what you’re in the mood for.",
        image: "mood",
        answers: [
          {
            name: "Something sweet & functional",
            results: {
              heading: "You’re just like millions of our fans – you’re here for Quest Protein Bars.",
              text: "We can’t blame you, they’re surprisingly sweet without all the sugar. We have a variety of flavors available. From chocolatey and indulgent to sweet & fruity, there’s a flavor for every type of tastebud. And best of all, each bar has at least 20g of protein with 3g net carbs or less and 2g of sugar or less. Yum.",
              buttonText: "Shop Quest Protein Bars Today",
              url: "https://www.questnutrition.com/collections/protein-bars",
              image: "protein-bars"
            }
          },
          {
            name: "Something indulgent with a good amount of protein",
            results: {
              heading: "We see your sweet tooth and hard work ethic and raise you one Quest Hero Protein Bar.",
              text: "Each of these sweet protein bars is coated in a chocolatey or white chocolatey outside with a satisfying crispy texture on the inside. And depending on the flavor, our Hero Bars are filled with sweet gooey center or an indulgent creamy filling. Oh, and every bar has 1 gram of sugar, 4g net carbs or less and 15-18 grams of protein. De-lish.",
              buttonText: "Shop Quest Hero Bars Today",
              url: "https://www.questnutrition.com/collections/hero-bars",
              image: "hero-protein-bars"
            }
          },
          {
            name: "I’m kinda thirsty, actually.",
            next: 5
          }
        ]
      },
      {
        contextText: "We could sense you were a little parched. Don’t worry, you’re in the right place. We have a nice selection of protein shakes that are sweet without all the sugar.",
        question: "Do you prefer a shake you can enjoy right away? Or do you prefer to make your own shakes?",
        image: "shake-or-powder",
        answers: [
          {
            name: "I’m ready to drink now!",
            results: {
              heading: "Might we suggest choosing from one of our three craveable flavors of Quest Protein Shakes?",
              text: "Choose from Chocolate, Vanilla or Salted Caramel. And don’t forget to get creative by adding them to your coffee or desserts. Each shake has 30g of protein, 4g of carbs or less and 1g of sugar.",
              buttonText: "Shop Quest Protein Shakes Today",
              url: "https://www.questnutrition.com/collections/protein-shakes",
              image: "protein-shakes"
            }
          },
          {
            name: "I like to add my own ingredients",
            results: {
              heading: "Totally understand, playing with your food can be fun.",
              text: " And <strong>Quest Protein Powders</strong> come in craveable flavors you can make, bake and shake with. Add a scoop to some water for a quick protein boost before or after a workout, make some protein pancakes or come up with your own creations.",
              buttonText: "Shop Quest Protein Powders Today",
              url: "https://www.questnutrition.com/collections/protein-powders",
              image: "protein-powders"
            }
          }
        ]
      },
    ];
    
    function makeQuestionMarkup(questionNumber) {
      // Get question based on the index passed from the form
      var question = questions[questionNumber];
      // Add new form markup
      var markup = '<p class="max-width">' + question.contextText + '</p>' + '<h3 class="max-width">' + question.question + '</h3>' + '<div class="flex">'
      
      // Add questions
      question.answers.forEach(function(answer, i) {
        var name = 'question-' + questionNumber;
        markup += '<label for="' + i + '">' + answer.name + '<input name="' + name + '" type="radio" value="' + i + '" id="' + i + '" name="' + name + '" required /><span class="checkmark"></span></label>';
      });
    
      // markup += '</div><img class="question-image" src="images/' + question.image + '.png" alt="Quest Nutrition" />'
    
      var imageUrl = question.image;
      $(".question-img-bg").css("background-image", "url(" + 'https://cdn.shopify.com/s/files/1/1941/9505/t/57/assets/' + imageUrl + '.png' + ")");
    
      return markup;
    };
    
    // Handle submit
    $('#quiz').submit(function(e) {
      // Make sure form submit doesn't reload page
      e.preventDefault();
    
      // Get the question number from the form data attribute
      var quiz = parseInt($(this).attr('data-question'), 10);
    
      // Add completed question to the completed array to handle back button
      completed.push(quiz);
      
      // Get the index of the question from the checked input.
      // This is how we figure out the next step
      var answerIndex = parseInt($('#quiz input:checked').val(), 10);
      // Answer
      var answer = questions[quiz].answers[answerIndex]
      
      // Update markup based on answer
      if (answer.next) {
        // If answer.next exists we need to generate the next question
        // and update the form data-question attribute
        updateQuestion(answer.next);
      } else {
        // If answer.next doesn't exist we need to show the product options
        // hide quiz
        // show results
        $('#form-inner').addClass('visually-hidden');
        $('.question-img-bg').addClass('visually-hidden');
        $('.quiz-wrap').removeClass('bottom-padding');
        $('#results').removeClass('visually-hidden');
        $('#submit').addClass('visually-hidden');
    
        var $heading = $(".results-heading");
    
        if (answer.results.heading) {
          $heading.text(answer.results.heading);
          $heading.removeClass('visually-hidden');
        } else {
          $heading.addClass('visually-hidden');
        }
    
        var $text = $(".results-text");
    
        if (answer.results.text) {
          $text.html(answer.results.text);
          $text.removeClass('visually-hidden');
        } else {
          $text.addClass('visually-hidden');
        }
    
        var $button = $(".results-button");
    
        if (answer.results.buttonText) {
          $button.text(answer.results.buttonText);
          $button.attr("href", answer.results.url);
          $button.removeClass('visually-hidden');
        } else {
          $button.addClass('visually-hidden');
        }
    
        var $img = $(".results-image");
    
        if (answer.results.image) {
          $img.attr('src', 'https://cdn.shopify.com/s/files/1/1941/9505/t/57/assets/' + answer.results.image + '.png');
          $('.results-image').removeClass('visually-hidden');
        } else {
          $('.results-image').addClass('visually-hidden');
        }
      }
    });
    
    function updateQuestion(index) {
      $('#form-inner').html(makeQuestionMarkup(index));
      $('#quiz').attr('data-question', index);
    
      // Hide previous button if on first question or results
      var $previous = $('#previous');
    
      if (index > 0) {
        $previous.removeClass('visually-hidden');
      } else {
        $previous.addClass('visually-hidden');
      }
    }
    
    // This might need some TLC
    $('#previous').click(function() {
      var prevIndex = completedIndex || completed.length;
      var previous = completed[prevIndex - 1];
      updateQuestion(previous);
      $('#form-inner').removeClass('visually-hidden');
      $('.question-img-bg').removeClass('visually-hidden');
      $('#submit').removeClass('visually-hidden');
      $('#results').addClass('visually-hidden');
      $('.quiz-wrap').addClass('bottom-padding');
      completedIndex = prevIndex !== 0 ? prevIndex - 1 : false;
    });
    
    // Make sure form submit doesn't reload page
    $('.reset').click(function(e) {
      e.preventDefault();
      updateQuestion(0);
      $('#form-inner').removeClass('visually-hidden');
      $('.question-img-bg').removeClass('visually-hidden');
      $('#submit').removeClass('visually-hidden');
      $('#results').addClass('visually-hidden');
      $('.quiz-wrap').addClass('bottom-padding');
    });
    
    $(".quiz-toggle").click(function(){
      $(".wrap-container-quiz").toggleClass("show-quiz");
      if (this.value == "Take Quiz!") {
        this.value = "Close Quiz";
        this.innerHTML = "Close Quiz";
      }
      else {
        this.value = "Take Quiz!";
        this.innerHTML = "Take Quiz!";
      }
    });
    

  } // end init

  return {
    init: init,
  }

}(jQuery));
    
$(document).ready(function() {
  Quiz.init()
  $('.culturecarouselslides').flickity({
  // options
  cellAlign: 'left',
  contain: true
});
})
